import axios from 'axios';
import { TIMEOUTS } from 'lib/Commons';

const defaultConfig = {
  _hideErrors: true,
  timeout: TIMEOUTS.LONG,
};

const PropertyDetailsApiSupport = {
  async get(url, config = {...defaultConfig}) {
    try {
      const response = await axios.get(url, config);
      return response.data;
    } catch (err) {
      //ignore
    }
  }
};

export const PropertyDetailsApi = {
  getSuburbInsights(propertyId, propertyType, coords = {}) {
    const path = `/api/properties/${ propertyId }/${ propertyType }/suburbinsights`;
    let params = {};
    if (coords.lat && coords.lng) {
      params = {
        latitude: coords.lat,
        longitude: coords.lng,
      };
    }
    return PropertyDetailsApiSupport.get(path, { params, _hideErrors: true });
  },
  getPropertyDetails(propertyId) {
    return PropertyDetailsApiSupport.get(`/api/properties/${ propertyId }/detail`);
  },
  /**
   * @param propertyId
   * @returns {Promise<{estimate: number, lowEstimate: number, clapiConfidence: string, confidence: string}>}
   */
  getPropertyIntellivalAvm(propertyId) {
    return PropertyDetailsApiSupport.get(`/api/properties/${ propertyId }/intellival/avm`);
  },
  /**
   * @param propertyId
   * @returns {Promise<{estimate: number, lowEstimate: number, fsd: number, confidence: string}>}
   */
  getPropertyRentalAvm(propertyId) {
    return PropertyDetailsApiSupport.get(`/api/properties/${ propertyId }/rental/avm`);
  },
  /**
   * @param propertyId
   * @returns {Promise<{history: {date: string, description: string}[]}>}
   */
  getPropertyTimeline(propertyId) {
    return PropertyDetailsApiSupport.get(`/api/properties/${ propertyId }/timeline`);
  },
  /**
   * @param propertyId
   * @returns {Promise<string>}
   */
  getPropertyNotes(propertyId) {
    return PropertyDetailsApiSupport.get(`/api/properties/${ propertyId }/notes`);
  },
  async putPropertyDataUpdate(propertyId, content) {
    try {
      const response = await axios.put(`/api/properties/${ propertyId }`, content);
      return response.data;
    } catch (e) {
      console.error(e);
    }
  }
};

export default PropertyDetailsApi;
